import type { ComponentType, LazyExoticComponent } from 'react';
import type { LucideIcon } from 'lucide-react';

export type ToolCategory =
  | 'workspace'
  | 'formatters'
  | 'encoders'
  | 'generators'
  | 'converters'
  | 'inspectors'
  | 'security'
  | 'text';

export interface ToolDefinition {
  id: string;
  name: string;
  description: string;
  keywords: string[];
  category: ToolCategory;
  icon: LucideIcon;
  /** Lazy component for code-splitting */
  component: LazyExoticComponent<ComponentType>;
}

export const CATEGORY_LABEL: Record<ToolCategory, string> = {
  workspace: 'Workspace',
  formatters: 'Formatters',
  encoders: 'Encoders',
  generators: 'Generators',
  converters: 'Converters',
  inspectors: 'Inspectors',
  security: 'Security',
  text: 'Text',
};
